import * as React from "react";
import { styled } from "@mui/system";
import MUIStep, { StepProps } from "@mui/material/Step";

export const Step = styled((props: StepProps) => <MUIStep {...props} />, {
  name: "Step",
  slot: "Root",
  overridesResolver: (props, styles) => [],
})(({ theme }) => ({
  "&.MuiStep-root  .MuiStepConnector-root": {
    top: 16,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  "&.MuiStep-root  .MuiStepConnector-line": {
    borderColor: theme.palette.primary.borderDefault,
    borderTopWidth: 2,
  },

  "&.MuiStep-root.MuiStep-vertical  .MuiStepContent-root": {
    borderLeft: "2px solid " + theme.palette.primary.borderDefault,
    marginLeft: 15,
  },

  "&.MuiStep-root .MuiSvgIcon-root.MuiStepIcon-root.Mui-active": {
    borderImage: "2px solid " + theme.palette.primary.baseVaporGradient,
    border: "transparent",
    color: "transparent",
    backgroundImage: theme.palette.primary.baseVaporGradient,
    ":hover": {
      color: "#00C3EA",
      cursor: "pointer",
    },
    "& .MuiStepIcon-text": {
      fill: "#fff",
    },
    "&.MuiStep-root .MuiStepLabel-label.MuiStepLabel-alternativeLabel": {
      marginTop: 1,
    },
    "&.MuiStep-root .MuiStepLabel-label.Mui-completed": {
      color: theme.palette.primary.infoBlue,
    },
    "&.MuiStep-root .MuiStepLabel-label": {
      color: theme.palette.primary.infoBlue,
    },

    "&.MuiStep-root .MuiSvgIcon-root.MuiStepIcon-root.Mui-actice": {
      borderRadius: "50%",
      height: 32,
      width: 32,
      color: theme.palette.primary.primaryBackgroundHover + " !important",
      background: theme.palette.primary.baseVaporGradient + " !important",
      borderColor: "transparent !important",
      "& .MuiStepIcon-text": {
        fill: "#fff",
      },
    },
  },
}));
